import type {
  ExtratoSolicitacaoDetalheResponse,
  ExtratoSolicitacaoItem,
} from "../../../../services/ExtractService";

export const EXTRACT_SINDICATO_FORCE_MOCK =
  process.env.REACT_APP_EXTRACT_SINDICATO_FORCE_MOCK === "true";

export const MOCK_SINDICATO_CNPJ = "65164618000132";

export const mockExtratoSindicatoListagem = (): ExtratoSolicitacaoItem[] => [
  {
    cnpj: MOCK_SINDICATO_CNPJ,
    sigla: "SINDAC",
    solicitacao: "1ª Solicitação",
    idSolicitacaoAvaliacao: 10,
    statusExtrato: { id: 2, nome: "Extrato enviado" },
    enviadoEm: "2026-08-07T15:20:00Z",
    atualizadoEm: "2026-08-07T15:20:00Z",
  },
  {
    cnpj: MOCK_SINDICATO_CNPJ,
    sigla: "SINDAC",
    solicitacao: "2ª Solicitação",
    idSolicitacaoAvaliacao: 11,
    statusExtrato: { id: 3, nome: "Extrato validado" },
    enviadoEm: "2026-07-10T10:00:00Z",
    atualizadoEm: "2026-07-12T14:30:00Z",
  },
  {
    cnpj: MOCK_SINDICATO_CNPJ,
    sigla: "SINDAC",
    solicitacao: "3ª Solicitação",
    idSolicitacaoAvaliacao: 12,
    statusExtrato: { id: 5, nome: "Inapto" },
    enviadoEm: null,
    atualizadoEm: null,
  },
];

export const mockExtratoSindicatoDetalhe = (
  solicitacaoAvaliacaoId: number | string = 10,
): ExtratoSolicitacaoDetalheResponse => ({
  solicitacaoAvaliacaoId: Number(solicitacaoAvaliacaoId) || 10,
  validacaoSindicato: null,
  dadosSindicato: {
    nome: "SINDICATO DEMONSTRAÇÃO FIEMG",
    sigla: "SINDAC",
    cnpj: MOCK_SINDICATO_CNPJ,
  },
  receitaOperacionalExtrato: {
    valorReceitaOperacional: 292796.02,
    faixaReceitaBonusExtrato: {
      titulo: "FAIXA 1",
      receitaMinima: 0,
      receitaMaxima: 50000,
      valorMinimo: 10000,
      bonusPotencial: 13500,
      valorMaximoPotencial: 23500,
    },
  },
  gruposCriteriosBonusExtrato: [
    {
      grupoCriterioId: 1,
      titulo: "Bônus",
      tituloResumo: "DOCUMENTO BÔNUS",
      ordem: 1,
      valorAlcancado: 3000,
      criterios: [
        {
          criterioId: 1,
          titulo: "PLANO DE NEGÓCIO SINDICAL",
          conforme: true,
          percentualBonus: 5,
          valor: 500,
        },
        {
          criterioId: 2,
          titulo: "BALANÇO PATRIMONIAL",
          conforme: true,
          percentualBonus: 5,
          valor: 500,
        },
        {
          criterioId: 3,
          titulo: "RELATÓRIO DE ATIVIDADES",
          conforme: true,
          percentualBonus: 5,
          valor: 500,
        },
      ],
    },
    {
      grupoCriterioId: 2,
      titulo: "Bônus Extra",
      tituloResumo: "DOCUMENTO BÔNUS EXTRA",
      ordem: 2,
      valorAlcancado: 500,
      criterios: [
        {
          criterioId: 10,
          titulo: "VENDA DE ESTANDES EM EVENTOS PROMOVIDOS PELA ENTIDADE",
          conforme: true,
          percentualBonus: 5,
          valor: 500,
        },
      ],
    },
  ],
  valorMinimoApoio: 10000,
  valorTotalApoio: 13500,
  deducoesExtrato: {
    deducaoAtrasoEntrega: {
      id: 1,
      documentacaoEnviadaEm: "2026-05-12T00:00:00Z",
      dataLimiteEntrega: "2026-04-30T00:00:00Z",
      diasAtraso: 12,
      percentualDeducao: 5,
      valorTotalApoio: 13500,
      valorDeducao: 675,
      deduzir: true,
    },
    deducaoTitulosEmAberto: {
      titulos: [
        {
          id: 1,
          recno: 1001,
          filial: "Araguari",
          titulo: "12345",
          parcela: "01",
          natureza: "Mensalidade",
          emitidoEm: "2026-01-01T00:00:00Z",
          vencimentoEm: "2026-02-01T00:00:00Z",
          diasAtraso: 30,
          valor: 1500,
          historico: "Título em aberto",
          deduzir: true,
        },
        {
          id: 2,
          recno: 1002,
          filial: "Ituiutaba",
          titulo: "67890",
          parcela: "01",
          natureza: "Mensalidade",
          emitidoEm: "2026-01-15T00:00:00Z",
          vencimentoEm: "2026-02-15T00:00:00Z",
          diasAtraso: 15,
          valor: 500,
          historico: "Título em aberto",
          deduzir: true,
        },
      ],
      valorTotalDeducao: 2000,
    },
    deducaoOutros: {
      deducoes: [
        { id: 1, descricao: "Baixa de estoque", valor: 1200, deduzir: true },
        {
          id: 2,
          descricao: "Custo para assessoria",
          valor: 300,
          deduzir: true,
        },
      ],
      valorTotalDeducao: 1500,
    },
  },
  valorTotalDeducoes: 4175,
  valorLiquidoApoio: 9325,
  valoresJaSolicitadosExtrato: {
    solicitacoes: [
      {
        solicitacao: "1ª Solicitação",
        solicitadoEm: "2026-05-15T00:00:00Z",
        valorApoiado: 2625,
      },
    ],
    valorTotalSolicitado: 2625,
  },
});

export type ConfirmacaoExtratoSindicatoResult = {
  sucesso: boolean;
  mock: boolean;
  mensagem: string;
  situacao?: string;
};

export async function mockConfirmarExtratoSindicato(
  concordaComValores: boolean,
): Promise<ConfirmacaoExtratoSindicatoResult> {
  await new Promise((resolve) => setTimeout(resolve, 600));

  if (!concordaComValores) {
    return {
      sucesso: true,
      mock: true,
      mensagem:
        "Registramos que você não está de acordo com os valores. A FIEMG será notificada para análise.",
    };
  }

  return {
    sucesso: true,
    mock: true,
    mensagem: "Extrato confirmado com sucesso. Status atualizado para Extrato validado.",
    situacao: "Extrato validado",
  };
}
